import { TDate } from '@api/io/session.io';
import EventRowDetails from '@fe-learner-common/components/Event/EventRowDetails';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventTexts } from './useEventTexts';

type EventRowProps = {
  date: TDate;
};

export const EventRow: FC<EventRowProps> = ({ date }) => {
  const intl = useIntl();
  const eventTexts = useEventTexts();
  const starts = date.starts ? new Date(date.starts).getTime() : 0;
  const ends = date.ends ? new Date(date.ends).getTime() : 0;
  const pastEvent = starts < Date.now();
  return (
    <EventRowDetails
      className="border-b-1 border-neutral-100 p-4"
      texts={eventTexts}
      eventType={date.type ?? ''}
      disabled={false}
      title={
        date.title
          ? date.title
          : intl.formatMessage({ id: 'catalog.tab.events.untitled' })
      }
      starts={starts}
      ends={ends}
      pastEvent={pastEvent}
      location={date.place?.location}
    />
  );
};
